export interface SelectInput$Props {
    name?: string;
    id?: string;
    label?: string;
    onChange?: any;
    onBlur?: any;
    value?: string;
    enabled: boolean;
    options: any[];
    width?: string | number;
  }
  
  export const SelectInput = ({
    name,
    id,
    label,
    onChange,
    onBlur,
    value,
    enabled,
    options,
    width,
  }: SelectInput$Props) => (
    <div className="nhsuk-form-group">
      <label className="nhsuk-label" htmlFor={id}>
        {label}
      </label>
      <select
        className="nhsuk-select"
        id={id}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        defaultValue={value}
        style={{ width: (width || "300px") }}
        disabled={!enabled}
      >
        {options.map((s) => (
          <option key={s.value} value={s.value}>
            {s.text}
          </option>
        ))}
      </select>
    </div>
  );
  